exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1kefSuo0uNZAva{color:#5e6c84;font-size:12px;font-weight:500;letter-spacing:.04em;line-height:16px;margin-top:16px;text-transform:uppercase}._2w85sGi5OdW2wf{margin:0;width:100%}._3kNiwjIoyLTow2{display:none}._2ciutp6C5PxYUd{color:#5e6c84;font-size:12px;line-height:16px;margin-top:12px}", ""]);

// exports
exports.locals = {
	"heading": "_1kefSuo0uNZAva",
	"upload": "_2w85sGi5OdW2wf",
	"fileInput": "_3kNiwjIoyLTow2",
	"tip": "_2ciutp6C5PxYUd"
};